module.exports = __webpack_public_path__ + "img/cleaning-svg.ea53f658.svg";